var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DropdownMenuList } from './dropdown-menu-list';
import { Popover } from '../popover';
import { styled } from '../styled';
import clsx from '../utils/clsx';
import { DropdownMenuContext } from './dropdown-menu-context';
import { dropdownMenuClasses, dropdownMenuComponentName, getDropdownMenuUtilityClass, } from './dropdown-menu-classes';
import { backdropClasses } from '../backdrop';
import { useMergedClasses } from '../styles/classes';
var Root = styled(Popover, { name: dropdownMenuComponentName, slot: 'Root' })(function (_a) {
    var _b;
    var theme = _a.theme, ownerState = _a.ownerState;
    return (_b = {
            marginTop: theme.spacing(0.5)
        },
        _b["& .".concat(dropdownMenuClasses.paper)] = __assign({ 
            // taken from MUI's menu component
            maxHeight: 'calc(100% - 96px)', minWidth: theme.typography.pxToRem(180), WebkitOverflowScrolling: 'touch', padding: theme.spacing(1), borderRadius: 8, border: "1px solid ".concat(theme.tokens.color_border_default), borderColor: theme.tokens.color_border_default, boxShadow: "0px 33px 80px rgba(0, 0, 0, 0.07), 0px 13.7866px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 7.37098px 17.869px rgba(0, 0, 0, 0.0417275), 0px 4.13211px 10.0172px rgba(0, 0, 0, 0.035), 0px 2.19453px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 0.913195px 2.21381px rgba(0, 0, 0, 0.0196802)" }, (ownerState.size === 'large' && {
            padding: theme.spacing(1.5),
            minWidth: theme.typography.pxToRem(260),
        })),
        _b["& .".concat(backdropClasses.invisible)] = {
            backgroundColor: 'transparent',
        },
        _b);
});
export var DropdownMenu = React.forwardRef(function (props, ref) {
    var _a = props.size, size = _a === void 0 ? 'default' : _a, _b = props.placement, placement = _b === void 0 ? 'right' : _b, onClose = props.onClose, _c = props.closeOnSelect, closeOnSelect = _c === void 0 ? true : _c, items = props.items, maxHeight = props.maxHeight, maxWidth = props.maxWidth, children = props.children, className = props.className, _d = props.PaperProps, PaperProps = _d === void 0 ? {} : _d, propClasses = props.classes, rootProps = __rest(props, ["size", "placement", "onClose", "closeOnSelect", "items", "maxHeight", "maxWidth", "children", "className", "PaperProps", "classes"]);
    var classes = useMergedClasses(dropdownMenuClasses, getDropdownMenuUtilityClass, propClasses);
    var handleItemSelect = function () {
        if (closeOnSelect && onClose) {
            onClose({}, 'itemSelect');
        }
    };
    return (React.createElement(DropdownMenuContext.Provider, { value: { size: size, onSelectItem: handleItemSelect } },
        React.createElement(Root, __assign({ className: clsx(classes.root, className), ownerState: { size: size }, ref: ref, transitionDuration: "auto", onClose: onClose, anchorOrigin: { vertical: 'bottom', horizontal: placement }, transformOrigin: { vertical: 'top', horizontal: placement }, BackdropProps: { invisible: true }, PaperProps: maxHeight || maxWidth
                ? __assign(__assign({}, PaperProps), { style: { maxHeight: maxHeight, maxWidth: maxWidth }, className: classes.paper }) : __assign(__assign({}, PaperProps), { className: classes.paper }) }, rootProps), items ? React.createElement(DropdownMenuList, { items: items }) : children)));
});
